import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import { BIconArrowLeft, BIconArrowRight, BIconExclamationTriangle } from 'bootstrap-vue'

Vue.component('BIconArrowRight', BIconArrowRight)
Vue.component('BIconArrowLeft', BIconArrowLeft)
Vue.component('b-icon-exclamation-triangle', BIconExclamationTriangle)
Vue.config.productionTip = false

// Create Element.remove() function if not exist, e.g. in IE
if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function () {
    if (this.parentNode) {
      this.parentNode.removeChild(this)
    }
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
